var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.856063 3.14499L3.64606 0.354994C3.83606 0.164994 4.15606 0.164994 4.34606 0.354994L7.13606 3.14499C7.45606 3.45499 7.23606 3.99499 6.78606 3.99499H4.99606V10.005C4.99606 10.555 4.54606 11.005 3.99606 11.005C3.44606 11.005 2.99606 10.555 2.99606 10.005V3.99499H1.20606C0.756063 3.99499 0.536063 3.45499 0.856063 3.14499ZM10.9961 8.00499V14.015H12.7961C13.2361 14.015 13.4661 14.555 13.1461 14.865L10.3561 17.645C10.1561 17.835 9.84606 17.835 9.64606 17.645L6.85606 14.865C6.53606 14.555 6.75606 14.015 7.20606 14.015H8.99606V8.00499C8.99606 7.45499 9.44606 7.00499 9.99606 7.00499C10.5461 7.00499 10.9961 7.45499 10.9961 8.00499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.6e47aa66b373caa70fd8d1843d4a6cc0.svg";
export { ForwardRef as ReactComponent };